// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(12px);
  transition: var(--transition);
  box-shadow: var(--shadow-sm);
  border-bottom: 1px solid transparent;
}

.navigation.scrolled {
  background: rgba(255, 255, 255, 0.98);
  box-shadow: var(--shadow-md);
  border-bottom: 1px solid var(--border-color);
}

.nav-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 0;
  gap: 40px;
}

.logo {
  display: flex;
  align-items: center;
  z-index: 1001;
  transition: opacity 0.3s ease;
}

.logo:hover {
  opacity: 0.85;
}

.logo-svg {
  height: 65px;
  width: auto;
}

.nav-menu {
  display: flex;
  align-items: center;
  gap: 32px;
  margin-left: auto;
  margin-right: 24px;
}

.nav-link {
  font-size: 15px;
  font-weight: 500;
  color: var(--text-light);
  position: relative;
  transition: var(--transition);
  padding: 6px 0;
}

.nav-link:hover {
  color: var(--primary-color);
}

.nav-link.active {
  color: var(--dark-color);
  font-weight: 600;
}

.nav-link::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: var(--primary-color);
  transition: width 0.3s ease;
  border-radius: 2px;
}

.nav-link:hover::after,
.nav-link.active::after {
  width: 100%;
}


.mobile-menu-toggle {
  display: none;
  flex-direction: column;
  gap: 5px;
  background: none;
  padding: 8px;
  z-index: 1001;
}

.mobile-menu-toggle span {
  width: 25px;
  height: 3px;
  background: var(--dark-color);
  border-radius: 3px;
  transition: var(--transition);
}

.mobile-menu-toggle.active span:nth-child(1) {
  transform: rotate(45deg) translate(8px, 8px);
}

.mobile-menu-toggle.active span:nth-child(2) {
  opacity: 0;
}

.mobile-menu-toggle.active span:nth-child(3) {
  transform: rotate(-45deg) translate(7px, -7px);
}

.donate-btn {
  display: inline-flex;
}

@media (max-width: 968px) {
  .nav-menu {
    position: fixed;
    top: 0;
    right: -100%;
    width: 300px;
    height: 100vh;
    background: var(--white);
    flex-direction: column;
    align-items: flex-start;
    padding: 100px 40px 40px;
    gap: 24px;
    box-shadow: -5px 0 20px rgba(0, 0, 0, 0.1);
    transition: right 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    margin: 0;
  }

  .nav-menu.active {
    right: 0;
  }

  .nav-link {
    font-size: 18px;
    width: 100%;
  }

  .nav-link::after {
    display: none;
  }

  .mobile-menu-toggle {
    display: flex;
  }

  .donate-btn {
    display: inline-flex;
  }
}

@media (max-width: 968px) {
  .logo-svg {
    height: 55px;
  }
}

@media (max-width: 480px) {
  .logo-svg {
    height: 50px;
  }
  
  .nav-wrapper {
    padding: 16px 0;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/Navigation.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,qCAAqC;EACrC,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,gCAAgC;EAChC,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;AACb;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,eAAe;IACf,MAAM;IACN,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,wBAAwB;IACxB,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;IACxB,SAAS;IACT,0CAA0C;IAC1C,mDAAmD;IACnD,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".navigation {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  background: rgba(255, 255, 255, 0.96);\n  backdrop-filter: blur(12px);\n  transition: var(--transition);\n  box-shadow: var(--shadow-sm);\n  border-bottom: 1px solid transparent;\n}\n\n.navigation.scrolled {\n  background: rgba(255, 255, 255, 0.98);\n  box-shadow: var(--shadow-md);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.nav-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 18px 0;\n  gap: 40px;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n  z-index: 1001;\n  transition: opacity 0.3s ease;\n}\n\n.logo:hover {\n  opacity: 0.85;\n}\n\n.logo-svg {\n  height: 65px;\n  width: auto;\n}\n\n.nav-menu {\n  display: flex;\n  align-items: center;\n  gap: 32px;\n  margin-left: auto;\n  margin-right: 24px;\n}\n\n.nav-link {\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--text-light);\n  position: relative;\n  transition: var(--transition);\n  padding: 6px 0;\n}\n\n.nav-link:hover {\n  color: var(--primary-color);\n}\n\n.nav-link.active {\n  color: var(--dark-color);\n  font-weight: 600;\n}\n\n.nav-link::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 0;\n  height: 2px;\n  background: var(--primary-color);\n  transition: width 0.3s ease;\n  border-radius: 2px;\n}\n\n.nav-link:hover::after,\n.nav-link.active::after {\n  width: 100%;\n}\n\n\n.mobile-menu-toggle {\n  display: none;\n  flex-direction: column;\n  gap: 5px;\n  background: none;\n  padding: 8px;\n  z-index: 1001;\n}\n\n.mobile-menu-toggle span {\n  width: 25px;\n  height: 3px;\n  background: var(--dark-color);\n  border-radius: 3px;\n  transition: var(--transition);\n}\n\n.mobile-menu-toggle.active span:nth-child(1) {\n  transform: rotate(45deg) translate(8px, 8px);\n}\n\n.mobile-menu-toggle.active span:nth-child(2) {\n  opacity: 0;\n}\n\n.mobile-menu-toggle.active span:nth-child(3) {\n  transform: rotate(-45deg) translate(7px, -7px);\n}\n\n.donate-btn {\n  display: inline-flex;\n}\n\n@media (max-width: 968px) {\n  .nav-menu {\n    position: fixed;\n    top: 0;\n    right: -100%;\n    width: 300px;\n    height: 100vh;\n    background: var(--white);\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 100px 40px 40px;\n    gap: 24px;\n    box-shadow: -5px 0 20px rgba(0, 0, 0, 0.1);\n    transition: right 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n    margin: 0;\n  }\n\n  .nav-menu.active {\n    right: 0;\n  }\n\n  .nav-link {\n    font-size: 18px;\n    width: 100%;\n  }\n\n  .nav-link::after {\n    display: none;\n  }\n\n  .mobile-menu-toggle {\n    display: flex;\n  }\n\n  .donate-btn {\n    display: inline-flex;\n  }\n}\n\n@media (max-width: 968px) {\n  .logo-svg {\n    height: 55px;\n  }\n}\n\n@media (max-width: 480px) {\n  .logo-svg {\n    height: 50px;\n  }\n  \n  .nav-wrapper {\n    padding: 16px 0;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
